module.exports = __webpack_public_path__ + "static/development-98a05a094aa12f5eb0aeb69ae114b522.svg";